<template>
  <div class="htInquiry">
    <ld-header
      style="position: absolute"
      @click-left="$router.go(-1)"
      transparent
      white
    >
      <img
        slot="left"
        class="custom-back"
        src="~Assets/images/back.png"
      >
    </ld-header>
    <div class="htInquiryWapper">
      <mescroll-vue :down="{use:false}">
        <div class="custom-van-swipe">
          <div class="pic-box custom-imgbox">
            <img src="~Assets/images/ht/inquiry-bg.png">
          </div>
          <a
            class="explain-btn"
            @click="explain()"
          >服务说明</a>
        </div>

        <div class="base-info custom-active-bg mb5">
          <div class="item-img custom-imgbox">
            <img v-lazy="data_.img">
          </div>
          <div class="content-box">
            <div class="title-box">
              <h1>
                {{ data_.jdmc }}
              </h1>
            </div>
            <p class="desc">
              地址：{{ data_.address }}
            </p>
            <p
              class="desc"
              v-if="data_.phone"
            >
              电话：{{ data_.phone }}
            </p>
          </div>
        </div>

        <van-cell
          :title="$t('H036','房型')"
          @click="van_action_sheet.show = true"
          is-link
        >
          <span class="black">{{ model_.fxmc ? model_.fxmc : '请选择' }}</span>
        </van-cell>

        <van-cell
          class="mb5"
          center
          :title="$t('H034','房间数')"
        >
          <van-stepper
            class="stepper inline-block"
            v-model="model_.rooms"
            min="1"
            max="5"
            integer
          />
        </van-cell>


        <div
          class="Grid Grid--1of3 van-hairline--bottom query-info__date bg-white pd12-28 mb5"
          @click="showDate"
        >
          <div class="Grid-cell text-center">
            <div class="Grid-cell--autoSize font12">
              {{ $t('H006','入住日期') }}
            </div>
            <div class="Grid-cell--autoSize query-info__date--weight font12 main-color">
              {{ model._checkInDate.monDay }}&nbsp;<span class="font-normal">{{ model._checkInDate.week }}</span>
            </div>
          </div>
          <div class="Grid-cell Grid-cell--center text-center font12">
            <span class="date-num">{{ $t('E017','共') }}<span class="query-info__tips--color">{{ model._days }}</span>晚</span>
            <div class="arrow-line arrow-line--white" />
          </div>
          <div class="Grid-cell text-center">
            <div class="Grid-cell--autoSize font12">
              {{ $t('H007','离店日期') }}
            </div>
            <div class="Grid-cell--autoSize query-info__date--weight font12 main-color">
              {{ model._checkOutDate.monDay }}&nbsp;<span class="font-normal">{{ model._checkOutDate.week }}</span>
            </div>
          </div>
        </div>

        <div class="mb5">
          <van-cell-group>
            <van-field
              v-model="model_.bzbz"
              clearable
              :label="$t('H226','备注')"
              right-icon="arrow"
              disabled
              placeholder="请输入备注"
              @click="$router.push({path: '/ht/htQuery/htRemark'})"
            />
          </van-cell-group>
        </div>

        <div class="mb5">
          <van-field
            :label="$t('D022','联系信息')"
            is-link
            :readonly="true"
            @click="$refs['linker'].toggle()"
          >
            <div
              slot="input"
              :class="{'gray': !linker.linkMan}"
            >
              {{ linker.linkMan ? linker.linkMan : '请输入' }} <span v-if="linker.linkTel">({{ linker.linkTel }})</span>

              <div class="font12 gray">
                {{ $t('D020','邮箱') }} ({{ linker.linkEmail }})
              </div>
            </div>
          </van-field>
        </div>
      </mescroll-vue>
    </div>

    <div class="fixed-btn-box">
      <ld-button
        main
        size="lg"
        @click="submit"
      >
        {{ $t('H080','提交询价') }}
        <p class="detailed-info">
          (共选择{{ model_.rooms }}{{ $t('E205','间') }})
        </p>
      </ld-button>
    </div>

    <ld-calendar
      ref="calendarDate"
      type="range"
      @selected="getDate"
      start-text="入住"
      end-text="离店"
    />

    <!-- 房型选择控件 -->
    <van-action-sheet
      v-model="van_action_sheet.show"
      title="选择房型"
    >
      <div class="pd0-10">
        <van-cell
          v-for="(i, index) in data_.hotelRoom"
          clickable
          :key="index"
          :title="i.fxmc"
          @click.stop="onSelect(i, index)"
        >
          <div slot="title">
            {{ model._international == 0 ? i.fxmc : i.roomName }}
            {{ model._international == 1 ? i.roomEnName : '' }}
            <a
              class="font12 text-underline pd0-10 main-color"
              @click.stop="popupAssignment(i)"
            >查看详情</a>
          </div>
          <van-checkbox
            :name="index"
            v-model="i.checked"
            slot="right-icon"
            @click="checkboxClick(i)"
          />
        </van-cell>
      </div>
    </van-action-sheet>

    <!-- 编辑联系人 -->
    <ld-edit-linker
      ref="linker"
      :data="linker"
    />
    <!-- 通过组件方式调用 -->
    <van-image-preview
      ref="imagePreview"
      v-model="van_image_preview.show"
      :images="van_image_preview.images"
      async-close
      class-name="custom-image-preview"
    >
      <div slot="cover">
        <div class="Grid van-image-preview-north">
          <div class="Grid-cell text-center">
            {{ van_image_preview.item.fxmc }}
          </div>
          <ld-icon
            class="close-icon"
            type="iconclose"
            @click="$refs['imagePreview'].close()"
          />
        </div>
        <div class="Grid Grid--1of3 van-image-preview-box">
          <div
            class="Grid-cell"
            v-if="van_image_preview.item.area"
          >
            {{ van_image_preview.item.area }}平米
          </div>
          <div
            class="Grid-cell"
            v-if="van_image_preview.item.bedType"
          >
            {{ van_image_preview.item.bedType }}
          </div>
          <div
            class="Grid-cell"
            v-if="van_image_preview.item.floor"
          >
            {{ van_image_preview.item.floor }}层
          </div>
          <div
            class="Grid-cell"
            v-if="van_image_preview.item.capacity"
          >
            可入住{{ van_image_preview.item.capacity }}人
          </div>
          <div class="Grid-cell">
            {{ van_image_preview.item.broadnetFee == '0' ? '免费宽带' : '收费宽带' }}
          </div>
        </div>
      </div>
    </van-image-preview>
  </div>
</template>

<script>
import { Swipe, SwipeItem, Field, Stepper, Button, ImagePreview, Dialog, ActionSheet, Popup, Checkbox, Cell, CellGroup  } from 'vant'
import { formatDate ,getDiffDays} from 'Utils/dateUtil'
import { getHotelRoom } from '../htDetails/hotelRoom'
import { mapState } from 'vuex'
import Vue from 'vue'
Vue.use(ImagePreview)
import ldButton from 'Common/ldButton'
import defaultMixin from '../../../../mixins/default'

export default {
  name: 'HtInquiry',
  mixins:[defaultMixin],
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Field.name]: Field,
    [Stepper.name]: Stepper,
    [Button.name]: Button,
    [ImagePreview.name]: ImagePreview,
    [Dialog.name]: Dialog,
    [ActionSheet.name]: ActionSheet,
    [Popup.name]: Popup,
    [Checkbox.name]: Checkbox,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    ldButton,
    ldCalendar: () => import('Common/ldCalendar'),
    MescrollVue: () => import('mescroll.js/mescroll.vue'),
    ldEditLinker: () => import('Components/ldEditLinker')
  },
  data() {
    return {
      van_swipe: {
        current: 0,
        images: [
          '',
        ]
      },
      /**
             * 联系人选择控件操作对象
             */
      van_popup: {
        show: false
      },
      /**
             * 房型选择控件操作对象
             */
      van_action_sheet: {
        show: false
      },
      data: {}, // 酒店详情数据模型
      /**
             * 保存询价单数据模型
             */
      model_: {
        appId: '', // 审批规则ID [×]
        bzbz: '', // 备注 [√]
        ccsqdId: '', // 出差申请单id [×]
        ccsqdNo: '', // 出差单号 [×]
        cityId: '', // 城市id [×]
        cityName: '', // 城市名称 [×]
        clbzj: '', // 差旅标准价,单间夜 [√]
        content: '', // 备注内容(没有使用) [×]
        costCenterCode: '', // 成本中心代码 [×]
        costCenterId: '', // 成本中心id [×]
        costCenterName: '', // 成本中心名称 [×]
        expectBudget: 0, // 期望价格 [×]
        fxid: '', // 房型id [√]
        fxmc: '', // 房型名称 [√]
        jdid: '', // 酒店id [√]
        ldrq: '', // 离店日期 [√]
        linkEmail: '', // 联系人邮箱 [√]
        linkMobile: '', // 联系电话 [√]
        linkman: '', // 联系人 [√]
        nights: 0, // 晚数 [√]
        orderFrom: '', // 订单来源 [√]
        projectCode: '', // 出差项目代码 [×]
        projectId: '', // 出差项目ID [×]
        projectName: '', // 出差项目名称 [×]
        rooms: 1, // 房间数 [√]
        rzrq: '', // 入住日期 [√]
        tripType: 1, // 出行类型,1是因公,2是因私 [√]
        vipStatus: '', // 差旅状态 [×]
        international: 1
      },
      van_image_preview: {
        show: false,
        images: [],
        index: 0,
        item: {}
      },
      linker: {
        linkMan: '',
        linkTel: '',
        linkEmail: ''
      },
    }
  },
  computed: mapState({
    model: function (state) {
      return state.ht.htSearchInfo
    },
    userInfo: (state) => state.app.userInfo,
    /**
         * 酒店详情数据模型
         */
    data_: (state) => state.ht.orderDetails,
    /**
         * 页面差旅标准对象
         */
    pageCtrl: function (state) {
      return state.ht.pageCtrl
    },
    interfacePlat: function (state) {
      return state.ht.interfacePlat
    },
  }),
  activated() {
    this.model_.cityId = this.model.cityId
    this.model_.cityName = this.model._cityName
    this.model_.clbzj = this.model._policy.jdjgbz
    this.model_.tripType = this.model.tripType
    this.model_.rzrq = this.model.checkInDate
    this.model_.ldrq = this.model.checkOutDate
    this.model_.nights = this.model._days
    this.linker.linkMan = this.userInfo.empInfo.empName,
    this.linker.linkTel = this.userInfo.empInfo.phoneNumber,
    this.linker.linkEmail = this.userInfo.empInfo.email
    this.model_.bzbz = this.model.customRemark
  },
  methods: {
    loadData() {

      // console.log(this.interfacePlat)
      // return
      if (this.model._international == 0) {
        getHotelRoom(this, {
          jdid: this.$route.query.jdid,
          checkInDate: this.model._checkInDate.date,
          checkOutDate: this.model._checkOutDate.date,
          tripType: this.model.tripType,
          interfacePlatEnum: this.interfacePlat.interfacePlatId
        }).then(v => {
          let res_ = v[0],
            res = v[1]
          //将获取到的酒店图片存储到this.van_swipe.images
          let _images = []
          res_.data.hotelImgs.forEach(element => {
            _images.push(element.url[0])
          })
          this.van_swipe.images = _images.length ? _images : ['http://via.placeholder.com/375']
          res.data.hotelRoom = v[2]
          // 通过房型id匹配房型图片合集，将房型图片数据合到房型对象信息中
          res_.data.roomsImgs.forEach(element_ => {
            res.data.hotelRoom.forEach(element => {
              if (element_.fxid == element.fxid) {
                element.roomsImgs = element_.url
              }
            })
          })
          this.$store.commit('ht/orderDetails', res.data)
          this.loading = false
        }).catch(e => {
          this.$store.commit('ht/orderDetails', { hotelRoom: [] })
          this.loading = false
        })
      }
      if (this.model._international == 1) {
        /**
         * 国际酒店获取酒店详情
         */
        this.$api['htQueryInt/hotelInfo']({
          'international': 0,
          'interfacePlatEnum': this.interfacePlat.platId,
          'jdid': this.$route.query.jdid
        }).then(res => {
          /**
           * 国际酒店获取价格计划列表
           */
          alert(0)

          this.$api['htQueryInt/pricePlanList']({
            'searchPlatZhid': '',
            'searchLocal': 0, // 是否查询本地价格计划 0否 1是 默认1。只针对OSS生效，指定价格计划id查询时无需传入此参数 ,
            'corpId': '', // 企业ID，OBT无需传入。OSS后台查询时如果选择了企业，需传入。集中采购页面从需从订单上获取传入 ,
            'tripType': this.model.tripType,
            'cityId': this.model.cityId,
            'interfacePlatId': this.interfacePlat.platId,
            'platHotelId': this.$route.query.jdid,
            'checkInDate': this.model.checkInDate,
            'checkOutDate': this.model.checkOutDate,
            'nationality': this.model._nationality.code,
            'adult': this.model._conditions.model.adultPopulation, // 每间房入住成人数量，最多 10 成人
            'children': this.model._conditions.model.childrenNumber, // 每间房入住的儿童数量，最多 10 儿童
            'childrenAge': this.model._conditions.model.ageItems.join(), // 儿童数量为0时传空字符串；多个儿童年龄时，必须使用半角逗号区分，而且其数量必须和 Children 参数一致，年龄输入范围 0 至 17 岁（包含 0 和 17）
            'roomCount': this.model._conditions.roomCount, // 预定酒店房间数量，最多 5 间
            'ratePlanId': ''
          }).then(res_ => {
            /**
                             * 将获取到的酒店图片存储到this.van_swipe.images
                             */
            if (res_.data) {
              let _images = res.data.detailImgBean && res.data.detailImgBean.hotelImgs && res.data.detailImgBean.hotelImgs[0].url || []
              this.van_swipe.images = _images
              res_.data.rooms.forEach(element => {
                element.visible = false
              })
              res.data.hotelRoom = res_.data.rooms
            } else {
              res.data.hotelRoom = []
            }
            this.$store.commit('ht/orderDetails', res.data)
          }).catch(() => {})
        }).catch(() => {})
      }
    },
    /**
         * 图片预览操作
         * @param {*} index
         */
    imagePreview(roomsImgs, index) {
      ImagePreview({
        images: roomsImgs,
        startPosition: index
      })
    },
    //  酒店选择入住/离店日期回调
    getDate(date) {
      [this.model.checkInDate, this.model.checkOutDate] = date;
      [this.model._checkInDate, this.model._checkOutDate] = [formatDate(date[0]), formatDate(date[1])];
      [this.model.rzrq, this.model.ldrq] = date;
      let day=getDiffDays(date[0],date[1])
      this.model._days = day
      this.model_.nights = day
      this.loadData()// 重新加载列表
    },
    //点击 去获取日期
    showDate() {
      if(this.pageCtrl.isChangeDate){
        this.$refs.calendarDate.toggle({
          defaultDate:[this.model._checkInDate.date,this.model._checkOutDate.date],
          minDate:this.model._min_date,
          maxDate:this.model._max_date,
        })
      }
    },
    //服务说明
    explain() {
      Dialog({ title: '服务说明', message: '提交人工询价后，服务人员会立即核实低价，并电话联系您，请保持电话畅通。通过人工询价可以向后台提交您的预订需求，从询价到下单，服务人员会提供全程服务。低于网站的报价预订同样优质的酒店。'})
    },
    //提交询价
    submit() {
      if(!this.model_.fxid) return this.$toast('请选择房型！')
      this.model_.jdid = this.data_.jdid.toString()
      this.model_.linkman = this.linker.linkMan
      this.model_.linkMobile = this.linker.linkTel
      this.model_.linkEmail = this.linker.linkEmail
      this.model_.international = this.model._international == 0 ? 1 : 0
      this.model_.singaZhid = this.interfacePlat.singaZhid
      this.model_.platZhid = this.interfacePlat.platZhid
      this.model_.interfacePlatEnum = this.interfacePlat.interfacePlatId

      this.$api['htQuery/saveNeedOrder'](this.model_).then(res => {
        this.model.customRemark = ''
        /**
         * 传值 将询价单id与酒店id
         */
        // this.$router.push({path: '/ht/htComplete', query: {xjdid: res.data, jdid: this.$route.query.jdid}})
        this.$router.push({path: '/ht/htQuery/htInquiryDetail/'+res.data+''})
      }).catch(() => {})
    },
    /**
     * 选择房型
     */
    onSelect(item) {
      this.data_.hotelRoom.forEach(element => {
        element.checked = false
      })
      item.checked = true
      this.model_.fxid = this.model._international == 0 ? item.fxid : item.roomId
      this.model_.fxmc = this.model._international == 0 ? item.fxmc : item.roomName
      this.van_action_sheet.show = false
    },
    /**
     * 点击房型下的价格计划
     * 为弹出菜单层赋值
     */
    popupAssignment(item) {
      this.van_image_preview.item = item
      this.van_image_preview.show = true
      this.van_image_preview.images = item.roomsImgs
    },
    checkboxClick(i) {
      setTimeout(() => {
        if (!i.checked) {
          i.checked = true
        }
      }, 0)
    }
  },
  watch: {}
}
</script>
<style lang="less" scoped>

@import '~Assets/styles/currency/ht.less';
@import '~Views/Ht/htQuery/preview.less';
.htInquiry {
  height: 100vh;
  padding-bottom: 55px;
}
.custom-van-swipe {
    text-align: center;
    width: 100%;
    height: 230px !important;
    overflow: hidden;
    > img {
      width: 100%;
      background-size: 100%;
      background-color: #f0efed;
      border: 0;
    }
  }

  .pic-box {
    position: relative;
    width: 100%;
    height: 230px;
    overflow: hidden;
    > img {
      position: absolute;
      width: 100%;
      height: 100%;
    }
  }

  .explain-btn {
    position: fixed;
    top: 26px;
    right: 20px;
    width: 44px;
    height: 44px;
    padding: 3px 5px;
    border-radius: 50%;
    border: 1px solid #fff;
    color: #fff;
    font-size: 12px;
    text-align: center;
    background: rgba(0, 0, 0, .1);
    z-index: 1;
  }

  .base-info {
    width: 100%;
    background: #fff;
    display: flex;
    box-align: center;
    align-items: top;
    padding: 10px;
    .right-pic {
      padding-right: 20px;
    }
    .item-img {
      position: relative;
      width: 90px;
      height: 90px;
      overflow: hidden;
      > img {
        position: absolute;
        width: 100%;
        height: 100%;
      }
    }
    .content-box {
      flex: 1;
      padding: 5px 10px 10px 5px;
      overflow: hidden;
      .title-box {
        h1 {
          font-size: 16px;
          color: #181818;
          line-height: 26px;
          display: inline-block;
          .label {
            font-size: 11px;
            padding: 0 0 0 5px;
          }
          .pic {
            width: 26px;
            vertical-align: middle;
          }
        }
      }
      .desc {
        font-size: 12px;
        color: #181818;
      }
    }
  }

  .item-box {
    background: #fff;
    padding: 0 10px;
    .top-box {
      padding: 12px 0;
    }
    .bottom-box {
      padding: 8px 0;
      .stepper {
        display: inline-block;
        padding: 0 10px;
      }
      span, .stepper {
        vertical-align: middle;
      }
    }
  }

  .fixed-btn-box {
    position: fixed;
    left: 0;
    bottom: 0;
    right: 0;
    color: #fff;
    .detailed-info {
      font-size: 12px;
      display: inline-block;
    }
  }

  .pd12-28 {
    padding: 12px 28px;
  }
  .date-num {
    padding: 0 10px;
    border-radius: 10px;
    border: 1px solid #ccc;
    display: inline-block;
    position: relative;
    top: -1px;
  }
  .htInquiryWapper{
    height: calc(100vh - 44px);
    overflow: hidden;
  }
</style>
